"use client";

import React from "react";
import { createGlobalStyle } from "styled-components";
import reboot, { defaultRebootTheme } from "styled-reboot";

import { getColor } from "./utils";

/**
 * Options for generating a custom Reboot/Reset css file
 * https://getbootstrap.com/docs/4.0/content/reboot/
 */
const theme = {
  ...defaultRebootTheme,
  black: getColor("black"),
  fontFamilyBase:
    '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  fontFamilyMonospace:
    'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  fontSizeBase: "14px",
  fontWeightBase: 400,
  lineHeightBase: 1.5,
  bodyColor: getColor("black"),
  bodyBg: getColor("white"),
  linkColor: getColor("primary"),
  linkDecoration: "none",
  linkHoverColor: getColor("primaryDark"),
  linkHoverDecoration: "underline",
  primaryColor: "", // Add the missing properties
  primaryColorDark: "",
  primaryColorLight: "",
  primaryColorTint: "",
  active: false,
};

// const rebootCss = reboot({theme});

/**
 * Global style component for consistent base styles across web projects
 *
 * Usage:
 * import { GlobalStyle } from '@nounproject/lingo-core';
 *
 * const App = () => {
 * <Wrapper>
 *    <GlobalStyle />
 * </Wrapper>
 * }
 */
const StyleWrapper = createGlobalStyle`
  ${reboot}

  html {
    font-feature-settings: "dlig", "zero", "ss01", "cv05", "cv10";
  }

  img {
    max-width: 100%;
  }

`;

const GlobalStyle = () => {
  return <StyleWrapper theme={theme} />;
};
export default GlobalStyle;
